import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, SxProps, Theme } from "@mui/material";
import { useEffect } from "react";
import { usePrevious } from "src/hooks/use-previous";

export interface SimpleDialogProps {
  title?: React.ReactNode;
  size?: "small" | "medium" | "large",
  customBody?: boolean,

  submitButton?: React.ReactNode;
  submitButtonColor?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning",
  submitButtonVariant?: "contained" | "outlined",
  submitButtonIcon?: React.ReactNode;
  onSubmit?: VoidFunction;
  submitDisabled?: boolean;

  open: boolean;
  onCancel: VoidFunction;
  onAfterClose?: VoidFunction;
  children?: React.ReactNode;

  buttons?: React.ReactNode;
  backTitle?: string;
  transitionDuration?: number;
  fullScreen?: boolean;

  sx?: SxProps<Theme>
}

export default function SimpleDialog({
  title,
  size = "small",
  backTitle,
  fullScreen = false,
  customBody = false,

  submitButton,
  submitButtonColor = "secondary",
  submitButtonIcon,
  submitDisabled = false,
  submitButtonVariant = "contained",
  onSubmit,

  buttons,

  open,
  onCancel,
  onAfterClose,
  children,
  transitionDuration,
  ...other
}: SimpleDialogProps) {

  const prevOpen = usePrevious(open);
  useEffect(() => {
    if (onAfterClose && prevOpen && !open) {
      setTimeout(() => {
        onAfterClose()
      }, 100);
    }
  }, [prevOpen, open, onAfterClose])

  return (
    <Dialog scroll="body" fullScreen={fullScreen} fullWidth maxWidth={size === "small" ? "sm" : "md"} open={open} onClose={submitDisabled ? undefined : onCancel} transitionDuration={transitionDuration || 100} {...other}>
      {customBody && children}
      {!customBody && <>
        <DialogTitle sx={{ p: (theme) => theme.spacing(2, 2, 1, 2) }}>
          {title}
        </DialogTitle>

        <DialogContent dividers sx={{ pt: 1, pb: 0, border: 'none', '-webkit-overflow-scrolling': 'initial' }}>
          {children}
        </DialogContent>

        <DialogActions>
          <Stack direction="row" gap={2} justifyContent="flex-end" flexGrow={1}>
            <Button variant="soft" onClick={onCancel} disabled={submitDisabled}>
              {backTitle || "Back"}
            </Button>

            {onSubmit && (
              <Button disabled={submitDisabled} variant={submitButtonVariant} color={submitButtonColor} startIcon={submitButtonIcon} onClick={onSubmit}>
                {submitButton}
              </Button>
            )}

            {buttons}
          </Stack>
        </DialogActions>
        </>}

    </Dialog>
  );
}